/* Fit media to the space left after all text and the link, without clipping content. */
if (!customElements.get('zarf-timeline')) {
  customElements.define('zarf-timeline', class extends HTMLElement {
    connectedCallback() {
      this.mobile = window.matchMedia('(max-width: 768px)');
      this.scheduleFit = () => {
        if (this.fitFrame) return;
        this.fitFrame = requestAnimationFrame(() => {
          this.fitFrame = null;
          if (this.isConnected) this.fit();
        });
      };
      this.resizeObserver = new ResizeObserver(this.scheduleFit);
      this.resizeObserver.observe(this);
      this.querySelectorAll('.zarfmb-boxsnitc, .zf-snitchcard, .zf-snitchcard-content, .zarf-overlay-btns').forEach(
        element => this.resizeObserver.observe(element)
      );
      window.addEventListener('resize', this.scheduleFit, { passive: true });
      this.mobile.addEventListener('change', this.scheduleFit);
      if (document.fonts) document.fonts.ready.then(() => {
        if (this.isConnected) this.scheduleFit();
      });
      this.scheduleFit();
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
      cancelAnimationFrame(this.fitFrame);
      this.fitFrame = null;
      window.removeEventListener('resize', this.scheduleFit);
      this.mobile.removeEventListener('change', this.scheduleFit);
    }

    fit() {
      if (!this.mobile.matches) {
        this.style.removeProperty('--timeline-media-height');
        return;
      }

      const slider = this.querySelector('.swiper');
      const wrapper = slider?.querySelector('.swiper-wrapper');
      const cards = Array.from(this.querySelectorAll('.zf-snitchcard'));
      if (!wrapper || !cards.length || !this.getBoundingClientRect().width) return;

      const pixels = value => parseFloat(value) || 0;
      const edges = element => {
        const style = getComputedStyle(element);
        return ['paddingTop', 'paddingBottom', 'borderTopWidth', 'borderBottomWidth']
          .reduce((sum, property) => sum + pixels(style[property]), 0);
      };
      const height = element => element?.getBoundingClientRect().height || 0;
      const heading = this.querySelector('.zarfmb-boxsnitc');
      const button = this.querySelector('.zarf-overlay-btns');
      const tools = slider.querySelector('.swiper-tool');
      const style = getComputedStyle(this);
      // min-height resolves 100svh in pixels, including the mobile browser chrome.
      const viewportHeight = pixels(style.minHeight);
      if (!viewportHeight) return;

      let textHeight = 0;
      let preferredMediaHeight = 0;
      for (const card of cards) {
        const video = card.querySelector('video');
        // Measure natural text, excluding the extra space used to equalize cards.
        const content = card.querySelector('.zf-snitchcard-content');
        textHeight = Math.max(textHeight, height(content) + edges(card) + edges(card.parentElement));
        preferredMediaHeight = Math.max(preferredMediaHeight, (video?.getBoundingClientRect().width || 0) * 5 / 6);
      }

      const gaps = pixels(style.rowGap) * ((height(heading) > 0 ? 1 : 0) + (height(button) > 0 ? 1 : 0));
      const reservedHeight = edges(this) + height(heading) + height(button) + gaps
        + edges(slider) + edges(wrapper) + height(tools) + textHeight;
      // If even text alone is too tall, retain natural scrolling rather than hide it.
      const mediaHeight = Math.max(0, Math.floor(Math.min(preferredMediaHeight, viewportHeight - reservedHeight - 2)));
      const value = `${mediaHeight}px`;
      if (this.style.getPropertyValue('--timeline-media-height') !== value) {
        this.style.setProperty('--timeline-media-height', value);
      }
    }
  });
}
